import { generatePath } from 'react-router';

import { Rarity, Sport } from '@sorare/core/src/__generated__/globalTypes';
import {
  ANY_SPORT_SCOUTING_CENTER_STATS,
  FOOTBALL_SCOUTING_CENTER_STATS,
  FOOTBALL_SCOUTING_CENTER_STATS_SO5_COMPETITION_SLUG,
} from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { LIFECYCLE, useLifecycle } from '@sorare/core/src/hooks/useLifecycle';
import { useSo5Competitions } from '@sorare/core/src/hooks/useSo5Competitions';
import { generateSportPath } from '@sorare/core/src/lib/routing/generateSportPath';

export const useMarketHomeFilters = () => {
  const { lifecycle, update } = useLifecycle();
  const { sport } = useSportContext();
  const { scoutableSo5Competitions } = useSo5Competitions();

  const footballRarity = lifecycle?.[LIFECYCLE.newFootballSeasonRarityFilter];
  const filtersBySport = lifecycle?.[LIFECYCLE.marketHomeFilters];
  const filters = filtersBySport?.[sport];

  const marketHomeFilters = (() => {
    return {
      ...filters,
      rarity: filters?.rarity || footballRarity || Rarity.limited,
    };
  })();
  const so5CompetitionSlug = marketHomeFilters?.competitionSlug;

  const { algoliaFilters } = scoutableSo5Competitions.find(
    competition => competition.slug === so5CompetitionSlug
  ) || { algoliaFilters: `sport:${sport.toLowerCase()}` };

  const scoutAllUrl = (() => {
    switch (sport) {
      case Sport.FOOTBALL:
        return generatePath(
          so5CompetitionSlug && so5CompetitionSlug !== 'DEFAULT'
            ? FOOTBALL_SCOUTING_CENTER_STATS_SO5_COMPETITION_SLUG
            : FOOTBALL_SCOUTING_CENTER_STATS,
          {
            slug: so5CompetitionSlug || '',
          }
        );
      default:
        return generateSportPath(ANY_SPORT_SCOUTING_CENTER_STATS, {
          sport,
        });
    }
  })();

  const updateRarity = (rarity: Rarity) => {
    update(LIFECYCLE.marketHomeFilters, {
      ...filtersBySport,
      [sport]: {
        ...filters,
        rarity,
      },
    });
  };

  return {
    marketHomeFilters,
    update,
    updateRarity,
    algoliaFilters,
    scoutAllUrl,
  };
};
